import { useTranslation, useSiteContext } from '@eti/providers';
import { css, etiColors, getTextStyles, mediaQueries } from '@eti/styles';
import { DangerousHtmlContent, Icon } from '@eti/components';
import { BaggageColumn, TripDetailsSegmentBaggageText } from './TripDetailsBaggageIncluded';

const additionalBaggageInformationStyles = css`
  ${getTextStyles()}; /* stylelint-disable-next-line order/properties-alphabetical-order */
  font-size: 0.625rem;
  padding-top: 5px;

  @media ${mediaQueries.large.up} {
    font-size: 0.6875rem;
    padding-top: 0;
  }
`;

const TripDetailsBaggageNotIncluded = () => {
  const { t } = useTranslation();
  const { market } = useSiteContext();

  return (
    <BaggageColumn>
      {market && market.code === 'US' ? (
        <TripDetailsSegmentBaggageText data-testid="baggage-not-included-but-with-additional-information">
          <DangerousHtmlContent
            className={additionalBaggageInformationStyles}
            content={t('Product.Baggage.NotIncluded.PriceSpecification.AdditionalInformation')}
          />
        </TripDetailsSegmentBaggageText>
      ) : (
        <>
          <Icon color={etiColors.grayScale[8]} id="no-baggage" />
          <TripDetailsSegmentBaggageText data-testid="baggage-not-included-text">
            {t('TripDetails.BaggageNotIncluded')}
          </TripDetailsSegmentBaggageText>
        </>
      )}
    </BaggageColumn>
  );
};

export default TripDetailsBaggageNotIncluded;
